import { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";

const ThemeContext = createContext({ theme: "light", toggle: () => {}, setTheme: () => {}, pushOverride: () => {}, popOverride: () => {} });

function getInitialTheme() {
  try {
    const saved = localStorage.getItem("app-theme");
    if (saved === "dark" || saved === "light") return saved;
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
  } catch { /* silent */ }
  return "light";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);
  const [override, setOverride] = useState(null); // "light" | "dark" | null → forza il tema temporaneamente senza toccare localStorage
  const savedRef = useRef(theme);

  useEffect(() => {
    const effective = override || theme;
    const root = document.documentElement;
    if (effective === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    // Persisti solo il tema utente, non l'override
    if (!override) {
      try { localStorage.setItem("app-theme", theme); } catch { /* silent */ }
      savedRef.current = theme;
    }
  }, [theme, override]);

  const setTheme = useCallback((t) => setThemeState(t === "dark" ? "dark" : "light"), []);
  const toggle = useCallback(() => setThemeState((t) => (t === "dark" ? "light" : "dark")), []);
  const pushOverride = useCallback((t) => setOverride(t === "dark" ? "dark" : "light"), []);
  const popOverride = useCallback(() => setOverride(null), []);

  return (
    <ThemeContext.Provider value={{ theme: override || theme, toggle, setTheme, pushOverride, popOverride }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
